"use client";

import React, { useState } from 'react';

interface DirectImageProps {
  src: string;
  alt: string;
  fallbackSrc?: string;
  width?: number;
  height?: number;
  fill?: boolean;
  priority?: boolean;
  className?: string;
  imgClassName?: string;
  [key: string]: any;
}

// Super simple direct image component - no fancy caching, just load the image directly
export default function DirectImage({
  src,
  alt,
  fallbackSrc = '/placeholder.png',
  width,
  height,
  fill,
  priority = false,
  className,
  imgClassName,
  ...props
}: DirectImageProps) {
  const [error, setError] = useState(false);
  
  // Handle image error by showing the fallback
  const handleError = () => {
    console.error(`Failed to load image: ${src}`);
    setError(true);
  };
  
  // The actual image URL to use
  const imageUrl = error ? fallbackSrc : (src || fallbackSrc);
  
  // Simple container + img approach for maximum compatibility
  return (
    <div 
      className={className}
      style={fill ? { position: 'relative', width: '100%', height: '100%' } : {}}
    >
      <img
        src={imageUrl}
        alt={alt}
        onError={handleError}
        className={imgClassName}
        style={fill 
          ? { position: 'absolute', width: '100%', height: '100%', left: 0, top: 0 } 
          : { width: width || 'auto', height: height || 'auto' }}
        loading={priority ? 'eager' : 'lazy'}
        {...props}
      />
    </div>
  );
}
